/**
 * Endereço de uma licença na grid "Listar Ativos", filtrada por
 * software e com o detalhe aberto. Licenças não têm mais aba própria
 * (issue #464).
 */
export function licencaUrl(licenseId?: string | null): string {
  const base = '/ativos?tab=lista&tipo=software';
  return licenseId ? `${base}&open=${encodeURIComponent(licenseId)}` : base;
}
